import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { AnalyticsService } from './analytics.service';
import { AnalyticsEvents } from './events.types';

@Directive({
    selector: '[appTrack]',
})
export class TrackEventDirective<K extends keyof AnalyticsEvents> implements OnInit {
    @Input('appTrack') eventName!: K;
    @Input() appTrackParams!: AnalyticsEvents[K];
    @Input() appTrackOnInit = false;

    constructor(private analyticsService: AnalyticsService, private elementRef: ElementRef) {}

    ngOnInit(): void {
        if (this.appTrackOnInit) {
            this.trackEvent();
        }
    }

    @HostListener('click', ['$event.target'])
    onClick(target: HTMLElement): void {
        if (this.appTrackOnInit || target !== this.elementRef.nativeElement) {
            return;
        }

        this.trackEvent();
    }

    private trackEvent(): void {
        if (!this.eventName) {
            console.warn("TrackEventDirective: No event name provided.");
            return;
        }

        this.analyticsService.track(this.eventName, this.appTrackParams);
    }
}
